import {fullDataCustomerDTO, fullDataItemDTO, NewOrderDataType} from "../models/device";
import {showlog} from "../utils";
import moment from "moment";
import {DATE_FORMAT_IT, DATETIME_ISO_FORMAT, ESOLVER_DATE_FORMAT, SALE_PACK_TYPE} from "../conf";
import {ExternalPromoAlerts, ExternalPromoRowType} from "../pages/orders-page-v2/static";
import ivaList from "../pages/orders-page-v2/codici_iva.json"
import {prepareEsolverNewCustomer, prepareEsolverNewCustomerAddress} from "./customer";

export const generateDocumentId = (seed?: number): string => {
	try {
		let activeSeed = seed || (new Date()).getTime();

		let gen =
			(
				Math.sin(activeSeed) * Math.pow(2, 32) + "." +
				Math.cos(activeSeed) * Math.pow(2, 32) + "." +
				Math.tan(activeSeed) * Math.pow(2, 32)
			)
				.split(".")
				.join("")
				.split("-")
				.join("")
				.substr(0, 40)
		;

		gen +=
			Array(40 - gen.length)
				.fill('0')
				.join("")
		;


		let bits = new Uint8Array();
		let bit = [];
		[...gen]
			.forEach(cifra => {
				//@ts-ignore
				while (cifra > 0) {
					//@ts-ignore
					bit.push(cifra & 0x1);
					//@ts-ignore
					cifra = cifra >> 1;
				}
				//@ts-ignore
				if (!!(bit.length % 4)) bit = bit.concat(Array(4 - (bit.length % 4)).fill(0));
			})
		;
		//@ts-ignore
		if (bit.length < 160) bit = bit.concat(Array(160 - bit.length).fill(0));

		let bytes = [];
		for (let i = 0; i < bit.length; i = i + 8) {
			let byte =
				(
					(bit[i] << 7) +
					(bit[i + 1] << 6) +
					(bit[i + 2] << 5) +
					(bit[i + 3] << 4) +
					(bit[i + 4] << 3) +
					(bit[i + 5] << 2) +
					(bit[i + 6] << 1) +
					bit[i + 7]
				);

			// range validi
			//     ( byte > 32 && byte < 127 )
			//     || ( byte > 160 && byte < 192 )
			// byte !== 34
			// byte !== 39


			while (
				byte < 33
				|| byte > 126
				|| byte === 34
				|| byte === 39
				|| byte === 44
				|| byte === 47
				|| byte === 59
				|| byte === 63
				|| byte === 92
				) {
				byte = (byte + 33) % 127
			}
//@ts-ignore
			bytes.push(byte);
		}

		return (String.fromCharCode(...bytes).substr(0, 20))
	} catch (e: any) {
		showlog("error in generateDocumentId(): ", e)
		return ""
	}

};

export function isExternalPromoManagement() {
	return false
}

export function getTotPriceArticles(articles: fullDataItemDTO[], importo: boolean = false): number {
	// il flag importo indica di considerare l'iva
	return (
		parseFloat((
				articles?.filter(({rowType}: fullDataItemDTO) => isExternalPromoManagement() ? (
					rowType === "Articolo" || rowType === "Extra Canvass"
				) : true)
					.reduce((totale: number, data: fullDataItemDTO) => {
						let qt = data?.qt || 0;
						totale += ((importo ? data?.details?.importo : data?.details?.prezzoNettoSconti) || 0) * qt;
						return totale;
					}, 0) || 0
			)?.toFixed(2)
		)
	)
}

export function getIvaFromCode(codIva?: string): number {
	try {
		return ivaList.find(({CodIva}: { CodIva: string }) => (codIva === CodIva))?.Aliquota || 0
	} catch (e) {
		showlog("error in getIvaFromCode(): ", e)
		return 0
	}
}

export function prepareEsolverHeader(currentOrder: any) {
	try {
		const deviceCache: NewOrderDataType = currentOrder.payload;
		const {agent} = currentOrder

		let totNettoMerce = getTotPriceArticles(deviceCache.items || []) || 0
		let totImponibile = totNettoMerce || 0
		if (!!deviceCache?.paymentDiscount) totImponibile -= (totImponibile * (deviceCache.paymentDiscount || 0) / 100);

		let totOmaggi = (deviceCache.items || []).reduce((totale: number, data: fullDataItemDTO) => {
			if (isExternalPromoManagement()) {
				if ((data.rowType === "Omaggio" && !!data.extPromoId) || data.rowType === "Extra Canvass")
					return data.rowType === "Omaggio" ? (totale + (data?.qt || 0)) : (totale + (data?.details?.omaggio || 0));
				else return totale;
			} else return totale + (data?.details?.omaggio || 0);
		}, 0);

		let totCharges = (
			(deviceCache.items || [])
				.filter(article => !!article.addebiti)
				// .map(article => article.addebiti)
				.reduce((totale, data) => {
					return totale + (data?.addebiti || 0);
				}, 0)
		)
		let totVATs = 0;
		let totOmaggioVATs = 0;

		(deviceCache.items || [])
			.map((item: fullDataItemDTO) => {
				showlog("map item")
				let qt = item.qt;
				let aliquota = getIvaFromCode(deviceCache.customer?.codIvaAgevolato || item.iva?.codIva)
				if (isExternalPromoManagement()) {

					if (item.rowType !== "Sconto merce") {

						if (item.rowType !== "Omaggio") {
							totVATs += (aliquota * (item?.details?.prezzoNettoSconti || 0) * qt / 100);
							if (!!item?.addebiti)
								totVATs += (aliquota * (item?.addebiti || 0) / 100)
						}

						if (!!item?.codIvaOmaggio) {
							let omaggioAliquota = getIvaFromCode(item?.codIvaOmaggio) || 0
							showlog('omaggioAliquota', omaggioAliquota);

							aliquota = omaggioAliquota
							showlog('aliquota', aliquota);
						}

						totOmaggioVATs += (
							aliquota * (item?.startPrice || 0)
							* (item?.rowType === "Omaggio" ? qt : (item?.details?.omaggio || 0))
							/ 100
						);

					}
				} else {

					totVATs += (aliquota * (item.details.prezzoNettoSconti || 0) * qt / 100) || 0;
					if (!!item.addebiti) totVATs += ((aliquota * (item.addebiti || 0) / 100) || 0);

					if (!!item.codIvaOmaggio) {
						let omaggioAliquota = getIvaFromCode(item.codIvaOmaggio) || 0
						showlog('omaggioAliquota', omaggioAliquota);

						aliquota = omaggioAliquota
						showlog('aliquota', aliquota);
					}

					totOmaggioVATs += (aliquota * (item?.startPrice || 0) * (item?.details?.omaggio || 0) / 100) || 0;

				}
			})
		const testata = {
			IdDocumento: deviceCache.documentId || "",
			DataRegistrazione: !!deviceCache.startOrderTime ?
				moment(deviceCache.startOrderTime).format(ESOLVER_DATE_FORMAT)
				: moment().format(ESOLVER_DATE_FORMAT),
			NumDocOriginale: deviceCache.documentNumber,
			TipoAnagrafica: deviceCache.customer?.tipoAnagrafica,
			CodCliFor: deviceCache.customer?.id,
			TipoAnagrAgente: 2,
			CodAgente: agent?.id,
			DatiSpedNum: deviceCache.deliveryAddress?.numProgr || 0,
			CodPorto: (deviceCache.commercialCondition?.codPorto || "").toString(),
			CodTrasportoMezzo: (deviceCache.commercialCondition?.codTrasportoMezzo || "").toString(),
			CodCondizPagamento: (deviceCache.paymentCondition?.codCondizPagamento || "").toString(),
			TipoAnagrVettore: 2,
			CodVettore: deviceCache.commercialCondition?.codVettore,
			StatoDocumento: deviceCache.orderStatus || 0,
			EmailIndirizzoCli: deviceCache.customer?.email,
			DataConsegna: moment(deviceCache.deliveryDate, DATETIME_ISO_FORMAT).startOf('day').format(ESOLVER_DATE_FORMAT),
			IdAnagGen: deviceCache.customer?.indirizzo?.id || 0,
			DBGruppo: agent.group,
			TotImponibile: totImponibile || 0,
			TotIVA: totVATs || 0,
			TotAddebiti: totCharges || 0,
			FirmaUltVarData: moment().format(DATETIME_ISO_FORMAT),
			FirmaUltVarOperatore: moment().format("DD/MM/YYYY HH:mm:ss"),
			IdClienteMobile: '0',
			Nota: deviceCache.note?.split('\'').join(' ') || '',
			TotNettoMerci: totNettoMerce || 0,
			TotScontoPagam: deviceCache.paymentCondition?.percSconto,
			TotOmaggi: totOmaggi || 0,
			ScontoCondizPagam: deviceCache.paymentDiscount || 0,
			FirmaCreazData: moment().format(ESOLVER_DATE_FORMAT),
			FirmaUltSincrData: moment().format(ESOLVER_DATE_FORMAT),
			CondizCommCliForNum: deviceCache.commercialCondition?.numeroProgressivo || 0,
			CodClassOrdWeb: deviceCache.documentClassification?.codClassificazioneDocumento || '',
			IntestCasella1: deviceCache.casella1 || '',
			IntestCasella2: deviceCache.casella2 || '',
			IntestCasella3: deviceCache.casella3 || '',
			Canvass: isExternalPromoManagement() ? (
				deviceCache.externalPromotions?.selectedCanvass?.id?.toString() || ''
			) : '',
			Alert: (
				isExternalPromoManagement()
				&& deviceCache.paymentDiscount !== deviceCache.paymentCondition?.percSconto
			) ? (ExternalPromoAlerts["Headers"]["PaymentDiscount"]?.id || '').toString() : ''
		}
		return testata
	} catch (e) {
		showlog("error in prepareEsolverHeader(): ", e)
		return ""
	}
}

export function prepareEsolverRows(currentOrder: any) {
	try {
		const deviceCache: NewOrderDataType = currentOrder.payload;

		const righe = (
			deviceCache.items
				.map((article: fullDataItemDTO) => {
					const rowId = generateDocumentId(Math.floor((Math.pow(2, 32) - 1) * Math.random())) || ""

					// imputazione a colli
					let qtaUdMInput = article.qt;
					if (!!
						article.venTipoImputazQta && article.venTipoImputazQta === SALE_PACK_TYPE
					) {
						if (article.venNumUnitaPerCollo > 1) {
							qtaUdMInput = article.qt / article.venNumUnitaPerCollo;
							if (qtaUdMInput - Math.floor(qtaUdMInput) > 0) qtaUdMInput = Math.floor(qtaUdMInput) + 1;
							else qtaUdMInput = Math.floor(qtaUdMInput);
						}
					}

					let alerts = ''
					if (isExternalPromoManagement()) {
						alerts = (Object.keys(ExternalPromoAlerts["Payloads"]) || [])
							.map((key: string) => ExternalPromoAlerts["Payloads"][key])
							.filter(({label}: { label: string, id: number }) => (
								(article?.alerts || []).some((alrt: string) => alrt === label)
							))
							.map(({id}: { label: string, id: number }) => id)
							.join(", ")
					}

					return {
						IdRigaDoc: rowId,
						IdDocumento: deviceCache.documentId,
						CodArt: article.codArt || article.codiceArticolo || "",
						DesArt: article?.details?.desArticolo || article.desArticolo || "",
						DataConsegna: moment(article.dataConsegnaRiga || deviceCache.deliveryDate, DATETIME_ISO_FORMAT).format(ESOLVER_DATE_FORMAT),
						Quantita: (
							isExternalPromoManagement()
								? (article?.rowType === "Omaggio" ? 0 : article?.qt)
								: article?.qt
						) || 0,
						QuantitaUdMInput: qtaUdMInput,
						UM: article?.um?.name,
						Prezzo: article?.startPrice || 0,
						PercSconto1: article?.details?.sconto1 || 0,
						PercSconto2: article?.details?.sconto2 || 0,
						PercSconto3: article?.details?.sconto3 || 0,
						PercSconto4: article?.details?.sconto4 || 0,
						PercSconto5: article?.details?.sconto5 || 0,
						ScontoUnitario: article?.details?.scontoUnitario || 0,
						QtaScontoMerce: (
							isExternalPromoManagement()
								? (article?.rowType === "Sconto merce" ? article?.qt : article?.details?.scontoMerce)
								: article?.details?.scontoMerce
						) || 0,
						QuantitaOmaggio: (
							isExternalPromoManagement()
								? (article?.rowType === "Omaggio" ? article?.qt : article?.details?.omaggio)
								: article?.details?.omaggio
						) || 0,
						ImportoValuta: article?.details?.prezzoNettoSconti * article?.qt || 0,
						Nota: article?.note?.split('\'').join(' ') || '',
						Addebiti: article?.addebiti || 0,
						NumRiga: article?.numeroProgressivo,
						VarianteArt: article?.varArt,
						CodPromo: isExternalPromoManagement() ? (((!!article?.extPromoId ? (article?.extPromoId || 0).toString() : '')) || '') : '',
						Alert: alerts,
						TipoRiga: isExternalPromoManagement() ? (
							Object.keys(ExternalPromoRowType)
								.map((key: string) => ExternalPromoRowType[key])
								.find(({label}: { label: string }) => label === article?.rowType)
								.id || 0
						) : 0,
						IdPrezzo: article.listino?.idPrezzo || 0
					}
				})
		)
		return righe
	} catch (e) {
		showlog("error in prepareEsolverRows(): ", e)
		return ""
	}
}

export function prepareOrderCurl(currentOrder: any): string {
	try {
		let curl = "";
		const header = prepareEsolverHeader(currentOrder);
		const rows = prepareEsolverRows(currentOrder);
		const customer = prepareEsolverNewCustomer(currentOrder);
		const address = prepareEsolverNewCustomerAddress(currentOrder);

		const orderBody = {
			"ORDINI": {
				"metadata": {
					"totalRows": 1,
					"name": "TESTATE",
					"condition": [],
					"action": "insert"
				},
				"payload": [header]
			},
			"ARTICOLI": {
				"metadata": {
					"totalRows": 1,
					"name": "RIGHE",
					"condition": [],
					"action": "insert"
				},
				"payload": rows
			}
		}
		const newCustomerBody = {
			"CLIENTI": {
				"metadata": {
					"totalRows": 1,
					"name": "ANAGRAFICA",
					"condition": [],
					"action": "insert"
				},
				"payload": [customer]
			},
			"INDIRIZZI": {
				"metadata": {
					"totalRows": 1,
					"name": "INDIRIZZI",
					"condition": [],
					"action": "insert"
				},
				"payload": [address]
			}
		}

		const body = {
			...orderBody,
			...((currentOrder?.payload?.customer as fullDataCustomerDTO).tipoAnagrafica == 6 ? newCustomerBody : {})
		}
		curl = "curl -X POST " + currentOrder.agent.syncUrl + "/mobileagent/api/orders "
			+ "-H 'Content-Type':'application/json' -H 'Accept':'application/json' -H 'Cache-Control':'no-cache' -H 'Pragma':'no-cache' -H 'Expires':'0' "
			+ "-H 'Authorization':'Bearer " + currentOrder.agent.token + "' -H 'Group':'" + currentOrder.agent.group + "' "
			+ "-d '" + JSON.stringify(body) + "'";

		return curl;
	} catch (e: any) {
		return ""
	}
}
